'use client';

/* eslint-disable no-console */
import { useEffect } from 'react';

async function checkServiceWorkerAvailability(serviceWorkerUrl: string): Promise<boolean> {
  try {
    const response = await fetch(serviceWorkerUrl, {
      method: 'HEAD',
      credentials: 'same-origin',
    });

    if (!response.ok || response.redirected) {
      console.log('Service worker not available or redirected in Next app', {
        status: response.status,
        redirected: response.redirected,
        url: response.url,
      });
      return false;
    }

    return true;
  } catch (error) {
    console.log('Service worker availability check failed in Next app', error);
    return false;
  }
}

const ServiceWorkerRegistration = () => {
  useEffect(() => {
    const isPWA =
      window.matchMedia('(display-mode: standalone)').matches ||
      Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone) ||
      document.referrer.includes('android-apk');

    if (!('serviceWorker' in navigator)) {
      return;
    }

    const registerServiceWorker = async () => {
      if (isPWA) {
        const serviceWorkerUrl = `${window.location.origin}/service-worker.js`;
        const isAvailable = await checkServiceWorkerAvailability(serviceWorkerUrl);

        if (!isAvailable) {
          console.log('Service worker script not accessible in Next app, skipping registration');
          return;
        }

        try {
          await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
        } catch (error) {
          console.log('Service worker registration failed in Next app', error);
        }
        return;
      }

      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        registrations.forEach((registration) => {
          registration.unregister();
        });
      } catch (error) {
        console.log('Service worker cleanup failed in Next app', error);
      }
    };

    registerServiceWorker();
  }, []);

  return null;
};

export default ServiceWorkerRegistration;
